import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * CloudServicesPage - Redirige vers /settings/connections
 * La gestion des connexions cloud est centralisée dans Settings > Connections
 * où les credentials sont stockés en base de données (chiffrés AES-256-GCM).
 */
const CloudServicesPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/settings/connections', { replace: true });
  }, [navigate]);

  return null;
};

export default CloudServicesPage;
